export default __webpack_public_path__ + "45e3d12.png";